import { useId } from "react";

// SVG needs unique IDs for the gradients, so we use useId to generate them
export default function UnavailableIcon() {
	const backgroundId = useId();
	const outlineId = useId();

	return (
		<svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="0.928571" y="0.928571" width="59.1429" height="59.1429" rx="29.5714" fill={`url(#${backgroundId})`} />
			<rect
				x="0.928571"
				y="0.928571"
				width="59.1429"
				height="59.1429"
				rx="29.5714"
				stroke={`url(#${outlineId})`}
				strokeWidth="0.857143"
			/>
			<path
				d="M27.6237 33.054L27.5271 17.9113C27.517 16.3237 28.7958 15.0284 30.3835 15.0183C31.9711 15.0082 33.2664 16.287 33.2765 17.8746L33.3731 33.0173C33.3831 34.6049 32.1043 35.9002 30.5168 35.9103C28.9292 35.9205 27.634 34.6415 27.6237 33.054Z"
				fill="#35363A"
			/>
			<path
				d="M30.4497 46.8994C32.3549 46.8994 33.8994 45.3549 33.8994 43.4497C33.8994 41.5445 32.3549 40 30.4497 40C28.5445 40 27 41.5445 27 43.4497C27 45.3549 28.5445 46.8994 30.4497 46.8994Z"
				fill="#35363A"
			/>
			<defs>
				<linearGradient
					id={backgroundId}
					x1="54.5"
					y1="0.499997"
					x2="14.2143"
					y2="58.3571"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.155982" stopColor="#BCBCBC" />
					<stop offset="1" stopColor="#7D7D7D" />
				</linearGradient>
				<linearGradient id={outlineId} x1="12.9286" y1="9.07143" x2="51.5" y2="53.2143" gradientUnits="userSpaceOnUse">
					<stop stopColor="#A8A8A8" />
					<stop offset="1" stopColor="#959595" />
				</linearGradient>
			</defs>
		</svg>
	);
}
